import { combineReducers } from 'redux'
import type { State as DiscoveryPanelState } from './discovery-panel'
import { discoveryPanelReducer as discoveryPanel } from './discovery-panel'
import type { State as DiscoveryPanelFavoriteState } from './discovery-panel-favorite'
import { discoveryPanelFavoriteReducer as discoveryPanelFavorite } from './discovery-panel-favorite'
import type { State as DiscoveryPanelRecentState } from './discovery-panel-recent'
import { discoveryPanelRecentReducer as discoveryPanelRecent } from './discovery-panel-recent'
import type { State as DiscoveryPanelSetState } from './discovery-panel-set'
import { discoveryPanelSetReducer as discoveryPanelSet } from './discovery-panel-set'
import type { State as GroupsState } from './groups'
import { groupsReducer as groups } from './groups'
import type { State as LibrariesState } from './libraries'
import { librariesReducer as libraries } from './libraries'
import type { State as ListState } from './list'
import { listReducer as list } from './list'
import type { State as SearchState } from './search'
import { searchReducer as search } from './search'
import type { State as SuggestedLibrariesState } from './suggested-libraries'
import { suggestedLibrariesReducer as suggestedLibraries } from './suggested-libraries'
export type ClientLibrariesState = {
  discoveryPanel: DiscoveryPanelState
  discoveryPanelFavorite: DiscoveryPanelFavoriteState
  discoveryPanelRecent: DiscoveryPanelRecentState
  discoveryPanelSet: DiscoveryPanelSetState
  suggestedLibraries: SuggestedLibrariesState
  groups: GroupsState
  libraries: LibrariesState
  list: ListState
  search: SearchState
}
export const clientLibrariesReducer = combineReducers({
  discoveryPanel,
  discoveryPanelFavorite,
  discoveryPanelRecent,
  discoveryPanelSet,
  suggestedLibraries,
  groups,
  list,
  libraries,
  search,
})
